/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Substatus_Pickup_ScheduledInputs */

const tr_geliver_substatus_pickup_scheduled = /** @type {(inputs: Geliver_Substatus_Pickup_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teslim Alım Planlandı`)
};

const en_geliver_substatus_pickup_scheduled = /** @type {(inputs: Geliver_Substatus_Pickup_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pickup Scheduled`)
};

const de_geliver_substatus_pickup_scheduled = /** @type {(inputs: Geliver_Substatus_Pickup_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abholung geplant`)
};

const ru_geliver_substatus_pickup_scheduled = /** @type {(inputs: Geliver_Substatus_Pickup_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Забор запланирован`)
};

/**
* | output |
* | --- |
* | "Pickup Scheduled" |
*
* @param {Geliver_Substatus_Pickup_ScheduledInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_substatus_pickup_scheduled = /** @type {((inputs?: Geliver_Substatus_Pickup_ScheduledInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Substatus_Pickup_ScheduledInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_substatus_pickup_scheduled(inputs)
	if (locale === "de") return de_geliver_substatus_pickup_scheduled(inputs)
	if (locale === "ru") return ru_geliver_substatus_pickup_scheduled(inputs)
	return tr_geliver_substatus_pickup_scheduled(inputs)
});